export default {"src":"/_next/static/media/vnd.b1d7d108.svg","height":24,"width":24};